import { WrapperAxios as Axios } from "./base";

import { CommonUtil as cu, APIResponse, Log } from "../types/elements";

export const LogAPI = {
  post: (log: Log): Promise<APIResponse<any>> => {
    return Axios.post("/api/log", log);
  },
};
